/* ============================================
   ROUTER CONFIGURATION
   The Creative Orchestra - GEMINI Framework
   React Router v6 configuration
   ============================================ */

import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router-dom';
import { MainLayout, ReadingLayout, WorkLayout } from '@layouts';
import { 
  HomePage, 
  NovelPage, 
  ThesisPage,
  WorkPage, 
  AboutPage,
  PublicationsPage,
  AcknowledgementsPage,
  NotFoundPage,
} from '@pages';

/**
 * Application Router
 * Defines all routes and their layouts
 */
const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      {/* Home Page - With footer and scrolling enabled */}
      <Route
        path="/"
        element={
          <MainLayout showFooter={true} fullHeight={false}>
            <HomePage />
          </MainLayout>
        }
      />

      {/* Novel Routes - Reading layout */}
      <Route
        path="/novel"
        element={
          <ReadingLayout>
            <NovelPage />
          </ReadingLayout>
        }
      />
      <Route
        path="/novel/:chapterId"
        element={
          <ReadingLayout>
            <NovelPage />
          </ReadingLayout>
        }
      />

      {/* Thesis Page - Main layout */}
      <Route
        path="/thesis"
        element={
          <MainLayout>
            <ThesisPage />
          </MainLayout>
        }
      />

      {/* Work Routes - Work layout with dynamic theming */}
      <Route
        path="/work/:workId"
        element={
          <WorkLayout>
            <WorkPage />
          </WorkLayout>
        }
      />

      {/* About Page - Main layout */}
      <Route
        path="/about"
        element={
          <MainLayout>
            <AboutPage />
          </MainLayout>
        }
      />

      {/* Publications Page - Main layout */}
      <Route
        path="/publications"
        element={
          <MainLayout>
            <PublicationsPage />
          </MainLayout>
        }
      />

      {/* Acknowledgements Page - Main layout */}
      <Route
        path="/acknowledgements"
        element={
          <MainLayout>
            <AcknowledgementsPage />
          </MainLayout>
        }
      />

      {/* 404 Not Found - Main layout */}
      <Route
        path="*"
        element={
          <MainLayout showFooter={true}>
            <NotFoundPage />
          </MainLayout>
        }
      />
    </>
  ),
  {
    // Future flags for React Router v7 compatibility
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    },
  }
);

export default router;
